import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { Button } from "@mantine/core";

export const NAV_STACK_GAP = "1.5rem";
export const CONTENT_TOP_SPACING = "1rem";

export const NAV_ITEMS = [
  { to: "/2026", label: "2026" },
  { to: "/writing", label: "writing" },
  { to: "/ai", label: "ai" },
];

const StyledSidebar = styled.nav`
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 0.95rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.075rem;
  width: 9rem;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  padding-top: ${CONTENT_TOP_SPACING};
  box-sizing: border-box;
  height: auto;
  
  display: flex;
  flex-direction: column;
  gap: ${NAV_STACK_GAP};

  div {
    display: flex;
    align-items: center;
  }
`;

const StyledHorizontalNav = styled.nav`
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08rem;
  display: flex;
  align-items: center;
  gap: 1.75rem;
  box-sizing: border-box;
  
  div {
    display: flex;
    align-items: center;
  }
`;

const StyledOverlay = styled.nav`
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08rem;
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 2rem;
  background-color: var(--bg-main);
  display: flex;
  flex-direction: column;
  gap: 1.75rem;

  > Button {
    align-self: flex-start;
    margin-bottom: 2rem;
  }
`;

const CustomNavLink = styled(NavLink)`
  color: var(--text-muted);
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
  padding-bottom: 4px;

  &:hover {
    color: var(--text-primary);
  }

  &.selected {
    color: var(--text-primary) !important;
    border-bottom: 2px solid var(--accent);
    font-weight: 600;
  }
`;

function NavLinkRow({ item, onNavigate }) {
  return (
    <CustomNavLink
      to={item.to}
      exact={item.exact ?? true}
      className="breadcrumb"
      activeClassName="selected"
      onClick={
        onNavigate
          ? (event) => {
              event.stopPropagation();
              onNavigate();
            }
          : undefined
      }
    >
      {item.label}
    </CustomNavLink>
  );
}

export default function NavMenu({ variant, onClose }) {
  const rows = NAV_ITEMS.map((item) => (
    <div key={`${item.to}-${item.label}`}>
      <NavLinkRow
        item={item}
        onNavigate={variant === "overlay" ? onClose : undefined}
      />
    </div>
  ));

  if (variant === "overlay") {
    return (
      <StyledOverlay
        role="dialog"
        aria-modal="true"
        aria-label="Site navigation"
      >
        <Button
          variant="outline"
          color="dark"
          size="xs"
          radius="xs"
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onClose();
          }}
        >
          close
        </Button>
        {rows}
      </StyledOverlay>
    );
  }

  if (variant === "horizontal") {
    return (
      <StyledHorizontalNav aria-label="Site navigation">
        {rows}
      </StyledHorizontalNav>
    );
  }

  return <StyledSidebar aria-label="Site navigation">{rows}</StyledSidebar>;
}
